import "./LabExamAcknowledgmentModal.scss";

import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Modal from "@material-ui/core/Modal";
import { Button, Text, Title } from "@runwayhealth/runway-components-react";
import { labExamCopy } from "@utils/labExam/labExamCopy";

type LabExamAcknowledgmentModalProps = {
  open: boolean;
  medicationName: string;
  onCancel: () => void;
  onProceed: () => void;
};

export const LabExamAcknowledgmentModal = ({
  open,
  medicationName,
  onCancel,
  onProceed,
}: LabExamAcknowledgmentModalProps) => {
  return (
    <Modal
      aria-labelledby="lab-exam-acknowledgment-title"
      aria-describedby="lab-exam-acknowledgment-description"
      open={open}
      className="lab-exam-modal"
      BackdropComponent={Backdrop}
      closeAfterTransition
      BackdropProps={{
        timeout: 500,
        className: "lab-exam-backdrop",
      }}
    >
      <Fade in={open}>
        <div className="lab-exam-paper">
          <div className="lab-exam-text-wrapper">
            <div id="lab-exam-acknowledgment-title">
              <Title as="h2" size="lg">
                {labExamCopy.modalTitle}
              </Title>
            </div>
            <div id="lab-exam-acknowledgment-description">
              <Text>{labExamCopy.acknowledgmentParagraph1(medicationName)}</Text>
            </div>
            <Text>{labExamCopy.acknowledgmentParagraph2}</Text>
            <Text>{labExamCopy.acknowledgmentParagraph3}</Text>
          </div>
          <div className="lab-exam-buttons-wrapper">
            <Button
              size="md"
              variant="outline"
              onClick={onCancel}
              isBlock
            >
              Cancel
            </Button>
            <Button
              size="md"
              variant="primary"
              onClick={onProceed}
              isBlock
            >
              Proceed
            </Button>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};
